import { render, staticRenderFns } from "./AsignarPersonalManualmenteConvocatoriaDialogComponent.vue?vue&type=template&id=8c1780b2"
import script from "./AsignarPersonalManualmenteConvocatoriaDialogComponent.vue?vue&type=script&lang=js"
export * from "./AsignarPersonalManualmenteConvocatoriaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports